<template>
  <div class="form-certification">
    <edit-table
      :option="option"
      :data="projectData"
      :form.sync="forms"
      @submit-add="handleSubmit"
      @submit-edit="handleUpdate"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    />
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue'
import WORKER from '@/api/worker/project';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { deepClone } from '@/util/util'

export default {
  components: {
    EditTable,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: String,
      default: '',
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      projectData: [],
      hasToStringTypes: ['select'],
      forms: {
        status: 1,
      },
    }
  },
  computed: {
    option() {
      const option = {
        drawer: true,
        menu: false,
        addBtn: false,
        editBtn: this.detailType !== 'view',
        delBtn: false,
        columns: [
          {
            label: this.i18n('projectId'),
            field: 'projectId',
            dictField: 'projectName',
            formOption: {
              type: 'select',
              dictCode: 'project',
            },
          },
          {
            label: this.i18n('status'),
            field: 'status',
            dictField: 'statusName',
            formOption: {
              type: 'select',
              dictBizCode: 'project_status',
            },
          },
          {
            label: this.i18n('startDate'),
            field: 'startDate',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM do yy',
            formOption: {
              type: 'date',
            },
          },
          {
            label: this.i18n('endDate'),
            field: 'endDate',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM do yy',
            formOption: {
              type: 'date',
            },
          },
          {
            label: this.i18n('remark'),
            field: 'remark',
          },
        ],
      }
      return option
    },
    form() {
      const res = []
      this.data.forEach(row => {
        const temp = row
        this.option.columns.forEach(item => {
          if (this.hasToStringTypes.indexOf(item.type) !== -1) {
            temp[item.field] = row[item.field].toString()
          }
        });
        res.push(temp)
      })
      return res
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    // 国际化
    i18n(param) {
      return this.$t(`_staff.labelProject.${param}`)
    },
    handleSubmit(done, row = {}) {
      const params = row
      WORKER.add({ workerId: this.currentId, projectId: params.projectId }).then(async res => {
        console.log(res, 'res=++')
        done()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
      }).catch(e => {
        done()
      })
    },
    handleUpdate(done, row) {
      const params = row
      WORKER.update({
        id: params.id, workerId: this.currentId, projectId: params.projectId, status: params.status, remark: params.remark,
      }).then(async res => {
        done()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
      })
    },
    handleRowDel(done, row) {
      // console.log(row, 'handleRowDel');
      WORKER.remove(row.id).then(res => {
        console.log(res, 'res+++')
        done()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    refreshChange() {
      this.onLoad()
    },
    async getList() {
      this.loading = true
      // { workerId: this.currentId }
      const res = await WORKER.getList(1, -1, { workerId: this.currentId })
      this.projectData = res.data.data.records
      this.loading = false
    },
    onLoad() {
      // this.projectData = deepClone(this.form)
      this.getList()
      // this.projectCopyData = deepClone(this.form)
    },
  },
}
</script>
<style lang="scss">
.form-certification{
  &-top{
    text-align: right;
  }
  .table-td{
    text-align: center;
    line-height: 50px;
    &-sm{
      width: 200px;
    }
  }
}
</style>
